module.exports = __webpack_public_path__ + "static/media/gameGroceryBagger.6454ec0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameGroceryBagger.png
// module id = 2620
// module chunks = 0